/** @format */

import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconStarFilled,
	homefieldIconStarHalf,
	homefieldIconStarOutlined
} from '@dsg-tech/homefield-angular-icons';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProductReviewsPipesModule } from '../pipes/product-reviews-pipes.module';
import { ReviewAISummaryComponent } from '../review-ai-summary/review-ai-summary.component';
import { ReviewAiProsConsComponent } from '../review-ai-pros-cons/review-ai-pros-cons.component';
import { ReviewButtonComponentModule } from '../review-button/review-button.module';
import { ReviewCarouselComponentModule } from '../review-carousel/review-carousel.module';
import { ReviewDrawerListComponentModule } from '../review-drawer-list/review-drawer-list.module';
import { ReviewFilterDrawerModule } from '../review-filter-drawer/review-filter-drawer.module';
import { ReviewLoadMoreButtonComponentModule } from '../review-load-more-button/review-load-more-button.module';
import { ReviewResponsiveRatingSummaryComponent } from '../review-responsive-rating-summary/review-responsive-rating-summary.component';
import { ReviewSecondaryRatingModule } from '../review-secondary-rating/review-secondary-rating.module';
import { ReviewStarsComponentModule } from '../review-stars/review-stars.module';
import { ReviewsDrawerContainerComponent } from './reviews-drawer-container.component';

@NgModule({
	declarations: [ReviewsDrawerContainerComponent],
	imports: [
		CommonModule,
		HomefieldIconLibraryModule,
		ProductReviewsPipesModule,
		ReviewAiProsConsComponent,
		ReviewAISummaryComponent,
		ReviewButtonComponentModule,
		ReviewCarouselComponentModule,
		ReviewDrawerListComponentModule,
		ReviewFilterDrawerModule,
		ReviewLoadMoreButtonComponentModule,
		ReviewResponsiveRatingSummaryComponent,
		ReviewSecondaryRatingModule,
		ReviewStarsComponentModule
	],
	exports: [ReviewsDrawerContainerComponent]
})
export class ReviewsDrawerContainerModule {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([
			homefieldIconStarFilled,
			homefieldIconStarHalf,
			homefieldIconStarOutlined
		]);
	}
}
